import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("lj_user") || "null");
    } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("lj_token", data.access_token);
    localStorage.setItem("lj_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("lj_token");
    localStorage.removeItem("lj_user");
    setUser(null);
    window.location.href = "/admin/login";
  };

  const refresh = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("lj_user", JSON.stringify(data));
      setUser(data);
    } catch { /* ignore */ }
    finally { setLoading(false); }
  };

  useEffect(() => {
    if (localStorage.getItem("lj_token") && !user) refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  admin: "Admin",
  branch_manager: "Branch Manager",
  executive: "Executive",
  telecaller: "Telecaller",
};

export const ROLE_RANK = {
  telecaller: 1,
  executive: 2,
  branch_manager: 3,
  admin: 4,
  super_admin: 5,
};

export const canRole = (user, min) =>
  user && ROLE_RANK[user.role] >= ROLE_RANK[min];
